import React, { useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'

import Welcome from 'components/book/WelcomePage'

import bookSelectors from 'store/selectors/booking'
import bookActions from 'store/modules/booking'
import routerSelectors from 'store/selectors/router'
import routerActions from 'store/modules/router'

const useStyles = makeStyles(theme => ({
  root: {
    
  },
}))

const BookingFormWelcome = ({
  
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const bookingFormData = useSelector(bookSelectors.bookingform)
  const embedHTML = useSelector(bookSelectors.embedHTML)

  const {
    project,
    bookingform,
  } = useSelector(routerSelectors.params)

  const onProceed = useCallback(() => {
    dispatch(routerActions.navigateTo('book.form.calendar', {
      project,
      bookingform,
      date: 'today',
    }))
  }, [
    project,
    bookingform,
  ])

  useEffect(() => {
    if(!bookingFormData) return
    const embedConfig = bookingFormData.meta.homepage_embed_widget
    if(!embedConfig || !embedConfig.enabled) return
    dispatch(bookActions.loadEmbedHTML({
      project,
      bookingform,
      days: embedConfig.days,
      slotsPerDay: embedConfig.slotsPerDay,
    }))
  }, [
    bookingFormData,
    project,
    bookingform,
  ])

  if(!bookingFormData) return null

  return (
    <div className={ classes.root }>
      <Welcome
        data={ bookingFormData }
        embedHTML={ embedHTML }
        onProceed={ onProceed }
      />
    </div>
  )
}

export default BookingFormWelcome